import PropTypes from 'prop-types';
import React from 'react';

import GenericErrorBoundary from 'src/components/ErrorBoundary/GenericErrorBoundary';

import LayoutErrorFallback from './LayoutErrorFallback';

/**
 * Wraps layout content in an error boundary with an error-screen fallback UI.
 * @param {object} props - Component props.
 * @param {React.ReactNode} props.children - Child content protected by the local boundary.
 * @returns {React.ReactNode} boundary-wrapped child content.
 */
function LayoutErrorBoundary({ children = null }) {
  return (
    <GenericErrorBoundary fallbackComponent={LayoutErrorFallback}>
      {children}
    </GenericErrorBoundary>
  );
}

LayoutErrorBoundary.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]),
};

export default LayoutErrorBoundary;
